import React, {Component} from 'react';
import PropTypes from 'prop-types';

import {TeamPropTypes, BasketPropTypes} from "../../../utils/propTypes";

class BasketComponent extends Component {
    static renderOb(ob) {
        if (ob > 0) {
            return <sup className="player__player__ob"> +{ob}</sup>;
        }
        return null;
    }

    getTeamResult(teamId) {
        return this.props.activeBasket.results.find(r => r.team === teamId);
    }

    getTeamScore(teamId) {
        const teamScore = this.props.resultsByTeam[teamId];
        let scoreSymbol = '';
        if (teamScore > 0) {
            scoreSymbol = '+';
        }
        return scoreSymbol + teamScore;
    }

    renderInput(result, teamId) {
        // initialValue is null when the team doesn't have a result for this basket
        // and input.value can't be null => let's make it an empty string instead
        const initialValue = result || '';
        let isActivePlayer = false;
        let inputClasses = 'inline-input';
        if (this.props.activeTeam.id === teamId) {
            isActivePlayer = true;
        }
        if (isActivePlayer) {
            inputClasses += ' inline-input--active';
        }

        return (
            <div className={inputClasses}>
                <input
                    value={initialValue}
                    placeholder="0"
                    readOnly="true"
                    onFocus={() => this.props.activateTeam(teamId)}
                />
                <span className="bar" />
            </div>
        );
    }

    renderTeam(team) {
        const result = this.getTeamResult(team.id);

        return (
            <div className="players__player players__player--form" key={team.id}>
                <div className="container">
                    <div className="col-xs-7">
                        <div className="player__player__name">{team.name}</div>
                        <div className="player__player__stats">(avg: {result.avg_result_for_the_basket},
                            best: {result.best_result_for_the_basket})</div>
                    </div>
                    <div className="col-xs-3">
                        {this.renderInput(result.result, team.id)}
                        {BasketComponent.renderOb(result.ob)}
                    </div>
                    <div className="col-xs-2">{this.getTeamScore(team.id)}</div>
                </div>
            </div>
        );
    }
    render() {
        return (
            <div className="players-list">
                {this.props.teams.map(t => (this.renderTeam(t)))}
            </div>
        );
    }
}

BasketComponent.propTypes = {
    teams: PropTypes.arrayOf(TeamPropTypes),
    activateTeam: PropTypes.func.isRequired,
    activeBasket: BasketPropTypes,
    activeTeam: TeamPropTypes,
    resultsByTeam: PropTypes.shape(),
};

export default BasketComponent;



// WEBPACK FOOTER //
// ./src/apps/result_entry/components/BasketComponent.js